<template>
    <div>
        <Breadcrumbs :type="type" :header="title" :url="url"></Breadcrumbs>
        <div class="flex items-center justify-between mb-6">
            <search-filter v-model="form.search" class="mr-4 w-full max-w-xl" @reset="reset">
                <template v-slot:filter>
                    <select v-model="form.trashed" class="form-select  w-28">
                        <option :value="null">Filter</option>
                        <option value="with">With Trashed</option>
                        <option value="only">Only Trashed</option>
                    </select>
                </template>
                <template v-slot:page>
                    <select v-model="form.length" class="form-select  w-20">
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="75">75</option>
                        <option value="100">100</option>
                        <option value="150">150</option>
                        <option value="200">200</option>
                    </select>
                </template>
            </search-filter>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <thead>
                    <tr class="text-left font-bold">
                        <th class="pb-2 pt-3 px-3">IP Address</th>
                        <th class="pb-2 pt-3 px-3">Reason</th>
                        <th class="pb-2 pt-3 px-3">Expires At</th>
                        <th class="pb-2 pt-3 px-3 text-center">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="blockedIp in blockedIps.data" :key="blockedIp.id"
                        class="hover:bg-gray-100 focus-within:bg-gray-100">
                        <td class="border-t pb-1 pt-1 px-3">
                            {{ blockedIp.ip }}
                        </td>
                        <td class="border-t pb-1 pt-1 px-3">
                            {{ blockedIp.reason || 'N/A' }}
                        </td>
                        <td class="border-t pb-1 pt-1 px-3">
                            {{ blockedIp.expires_at ? new Date(blockedIp.expires_at).toLocaleString() : 'Never' }}
                        </td>
                        <td class="w-px border-t pb-1 pt-1 px-3 text-center">
                            <div class="flex items-center px-2" v-if="permission.delete > 0">
                                <button class="px-4 py-2 text-red-600 hover:text-red-800" @click="destroy(blockedIp.id)"
                                    title="Delete Blocked IP">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="blockedIps.data.length === 0">
                        <td class="px-3 py-1 border-t" colspan="4">No blocked IPs found.</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <pagination class="mt-6" :links="blockedIps.links" />
    </div>
</template>

<script>
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import { ref, toRefs, inject } from 'vue'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import Breadcrumbs from '@/Shared/Breadcrumbs'
import StatusLevel from '@/Shared/StatusLevel'
import Button from '@/Shared/Button'
import { Inertia } from '@inertiajs/inertia'

export default {
    components: {
        Head,
        Icon,
        Link,
        Pagination,
        SearchFilter,
        Breadcrumbs,
        StatusLevel,
        Button
    },
    layout: Layout,
    props: {
        filters: Object,
        blockedIps: Object,
        permission: Object,
    },
    setup(props) {
        const { filters, blockedIps, permission } = toRefs(props)
        const form = ref({
            search: filters.value.search,
            trashed: filters.value.trashed,
            length: filters.value.length ? filters.value.length : 15,
        })
        const type = ref('index')
        const title = ref('Blocked IPs')
        const url = ref('/backend/blocked-ips')
        const swal = inject('$swal')
        const reset = () => {
            form.value = mapValues(form, () => null)
        }

        const destroy = (id) => {

            swal({
                title: 'Are you sure?',
                text: "Do you really want to delete this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    Inertia.delete(`${url.value}/${id}`)
                    swal.fire(
                        'Deleted!',
                        'Your information has been deleted.',
                        'success'
                    )
                }
            });
        }

        return {
            filters,
            blockedIps,
            form,
            type,
            title,
            url,
            reset,
            permission,
            destroy
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get('/backend/blocked-ips', pickBy(this.form), { preserveState: true })
            }, 150),
        },
    }
}
</script>
